export const environment = {
  production: true,
  //APIUrl:  "https://localhost:44320",
  //APIUrl:  'https://portal.distone.com/smoothiekingapi',
  //APIUrl:  "https://shopapi.preiser.com",
  //APIUrl:  "https://portal.distone.com/planetfitnessapi",
  //APIUrl:  'https://portal4.distone.com/ecommercetestAPI',
  //APIUrl:  "https://portal.distone.com/barnhillboltapi",
	//APIUrl:  "https://portal4.distone.com/fitness19api",
  //APIUrl:  "https://portal3.distone.com/housewaresapi",
  //APIUrl:  "https://portal3.distone.com/southernapi",
  APIUrl:  "https://portal2.distone.com/KCELECTRAPI",
  //APIUrl:  "https://portal2.distone.com/ALIQUANTUMAPI",
  //APIUrl:  "https://portal4.distone.com/BOSTONapi",
  //APIUrl:  "{{AdminURL}}",
  cookname: 'KCELECTR092222',
	storagetime:  ((60000 * 1 * 60) * 12),
  isheaderbanner:0,
  ga:'G-YG07B96CJY',
  istranslate:0,
};